module.exports = __webpack_public_path__ + "media/images/lb/520-41512825deb52470f493df7601a242b1.svg";